import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Sparkles } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Seo } from "@/components/Seo";

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-hero text-primary-foreground">
      <Seo
        title="Take & Pay — Mini conveniência autônoma premium"
        description="Pegue o produto da prateleira, escaneie o código de barras pelo app e pague em segundos. Conveniência premium dentro do seu prédio."
        path="/"
      />
      
      <div className="mx-auto flex min-h-screen max-w-6xl flex-col px-6 py-10 lg:px-12">
        <header className="flex items-center justify-between">
          <Logo variant="light" />
          <span className="hidden text-xs font-medium uppercase tracking-[0.2em] text-primary-foreground/70 md:block">
            Balneário Camboriú · Premium
          </span>
        </header>

        <main className="grid flex-1 items-center gap-12 py-12 lg:grid-cols-2">
          <div className="space-y-8">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent/40 bg-primary/30 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.2em] text-accent backdrop-blur">
              <Sparkles className="h-3.5 w-3.5" /> Mini conveniência autônoma
            </span>
            <h1 className="font-display text-5xl leading-[1.05] text-balance md:text-7xl">
              <span className="sr-only">Take &amp; Pay — mini conveniência autônoma premium. </span>
              <span aria-hidden="true">Pegou.<br /><span className="text-accent">Pagou.</span><br />Aproveitou.</span>
            </h1>
            <p className="max-w-md text-lg leading-relaxed text-primary-foreground/80">
              A experiência premium de conveniência dentro do seu prédio. Escolha, escaneie o QR
              da porta e finalize tudo pelo app em segundos.
            </p>
            <div className="flex flex-wrap items-center gap-3 text-sm text-primary-foreground/70">
              <ShieldCheck className="h-4 w-4 text-accent" />
              Pagamentos seguros · Portas inteligentes · Suporte 24/7
            </div>
          </div>

          <div className="space-y-5">
            <Link
              to="/cliente"
              className="group flex items-center justify-between rounded-3xl bg-gradient-gold p-7 text-primary shadow-gold transition-smooth hover:-translate-y-1"
            >
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.2em] opacity-70">Para moradores</p>
                <h2 className="mt-1 font-display text-3xl">Entrar como cliente</h2>
                <p className="mt-2 max-w-sm text-sm opacity-80">
                  Compre, escaneie a porta e retire seu item em poucos segundos.
                </p>
              </div>
              <ArrowRight className="h-7 w-7 transition-smooth group-hover:translate-x-1" />
            </Link>
          </div>
        </main>

        <footer className="flex items-center justify-between text-xs text-primary-foreground/50">
          <span>© Take & Pay {new Date().getFullYear()}</span>
          <Link
            to="/admin-login"
            aria-label="v1.0 · Yacht Tower — Acesso administrativo"
            className="text-[10px] text-primary-foreground/20 transition-smooth hover:text-accent/60"
          >
            v1.0 · Yacht Tower
          </Link>
        </footer>
      </div>
    </div>
  );
};

export default Index;
